import { useQuery } from 'react-query';
import Suggestion from '../../../models/Suggestion';
import createQueryString from '../../../utils/createQueryString';

function useSuggestionsByTaskId(taskId?: string) {
    return useQuery<Suggestion[]>(['suggestions', createQueryString('', { taskId: taskId })]);
}

export default useSuggestionsByTaskId;
